import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Grid, Row, Col } from '@sm/wds-react';

import AppPlaceHolderImg from '../../../../static/images/app-placeholder.png';
import AppLink from '../../../../components/AppLink';

import './apps-grid.scss';

const AppsGrid = ({ apps }) => {
  return (
    <Grid
      noBleeds
      className="sm-apps-grid__apps wds-m-t-3"
      data-testid="AppsGrid"
    >
      <Row>
        {apps.map(app => (
          <Col key={app.id} lg={4} md={6} sm={12} xs={12} className="wds-m-b-5">
            <AppLink
              app={app}
              className="sm-apps-grid__apps-link"
              data-testid="AppsGrid_Link"
            >
              <div className="sm-apps-grid__app wds-flex wds-flex--y wds-flex--y-center wds-flex--x-center wds-p-5">
                <img
                  src={app.logo ? app.logo : AppPlaceHolderImg}
                  alt={app.name}
                  className="sm-apps-grid__app-logo"
                />
                <Typography>{app.name}</Typography>
                <If condition={app.categories.length}>
                  <Typography color="dark-muted">
                    <span
                      className="sm-apps-grid__apps-category"
                      data-testid="AppsGrid_Category"
                    >
                      {app.categories[0].name}
                    </span>
                  </Typography>
                </If>
              </div>
            </AppLink>
          </Col>
        ))}
      </Row>
    </Grid>
  );
};

AppsGrid.propTypes = {
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      logo: PropTypes.string.isRequired,
      links: PropTypes.shape({
        detail: PropTypes.string.isRequired
      }),
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired
        }).isRequired
      )
    })
  ).isRequired
};

export default AppsGrid;
